var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageHomepage',{attrs:{"featured-articles":_vm.featuredArticles,"block-homepage-content":_vm.blockHomepageContent,"featured-banners":_vm.featuredBanners ? _vm.featuredBanners : [],"featured-products":{mostSoldProducts: _vm.mostSoldProducts, newestProducts: _vm.newestProducts},"info-boxes":_vm.infoBoxes}})
}
var staticRenderFns = []

export { render, staticRenderFns }